module.exports = __webpack_public_path__ + "img/drag-drop.a06b041b.webp";